import { render, staticRenderFns } from "./ShipModal.vue?vue&type=template&id=8d6f8d60&scoped=true"
import script from "./ShipModal.vue?vue&type=script&lang=js"
export * from "./ShipModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6f8d60",
  null
  
)

export default component.exports